import { computed } from 'vue'
import { useUserStore } from '@/store/userStore'
import { Permission } from '@/configuration/permissions/permission'

export const usePermissions = () => {
    const userStore = useUserStore()

    const userPermissions = computed(() => ({
        /*
        *  Common permissions
        */
        // Read
        canViewReports: userStore.hasPermission(Permission.CanViewReports),
        // Edit
        canEditThresholdsAndRecommendations: userStore.hasPermission(Permission.CanEditThresholdsAndRecommendations),
        canSetReferenceReports: userStore.hasPermission(Permission.CanSetReferenceReports),

        /*
        *  Transformer permissions
        */
        // Read
        canViewTransformerData: userStore.hasPermission(Permission.CanViewTransformerData),
        canViewTransformerRecommendations: userStore.hasPermission(Permission.CanViewTransformerRecommendations),
        canViewTransformerReports: userStore.hasPermission(Permission.CanViewTransformerReports),
        // Edit
        canEditTransformerRecommendations: userStore.hasPermission(Permission.CanEditTransformerRecommendations),
        canEditTransformerComments: userStore.hasPermission(Permission.CanEditTransformerComments),
        canOverrideTransformerConditionStatus: userStore.hasPermission(Permission.CanOverrideTransformerConditionStatus),
        canSetTransformerAsNoAction: userStore.hasPermission(Permission.CanSetTransformerAsNoAction),
        canExportTransformerReports: userStore.hasPermission(Permission.CanExportTransformerReports),
        canExcludeTransformerReports: userStore.hasPermission(Permission.CanExcludeTransformerReports),

        /*
        *  Generator permissions
        */
        // Read
        canViewGeneratorsData: userStore.hasPermission(Permission.CanViewGeneratorsData),
        canViewGeneratorRecommendations: userStore.hasPermission(Permission.CanViewGeneratorRecommendations),
        canViewGeneratorReports: userStore.hasPermission(Permission.CanViewGeneratorReports),
        // Edit
        canEditGeneratorRecommendations: userStore.hasPermission(Permission.CanEditGeneratorRecommendations),
        canEditGeneratorComments: userStore.hasPermission(Permission.CanEditGeneratorComments),
        canOverrideGeneratorConditionStatus: userStore.hasPermission(Permission.CanOverrideGeneratorConditionStatus),
        canSetGeneratorAsNoAction: userStore.hasPermission(Permission.CanSetGeneratorAsNoAction),
        canExportGeneratorReports: userStore.hasPermission(Permission.CanExportGeneratorReports),
        canExcludeGeneratorReports: userStore.hasPermission(Permission.CanExcludeGeneratorReports),
    }))

    return {
        userPermissions,
    }
}
